/* GASSISA
=========================================================================================
* Descripción: Catálogo de Accesos
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 13/12/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 21/03/2026 | Lic. José Luis Aragón Cervantes  | Arquitectura validación tipo Clientes
*      3       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Modal de eliminación de accesos
*      4       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Orden configurable de menús
*      5       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Bloqueo de edición en menús, permisos y alcances
*      6       | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Helpers de validación en contraseñas y claves secretas
*      7       | 27/08/2026 | Lic. José Luis Aragón Cervantes  | Orden vertical de grupos y péginas de menú
* ---------------------------------------------------------------------------------------
*/

import TextField from "../../ui/TextField";
import Autocomplete from "../../ui/Autocomplete";
import React, { useEffect, useMemo, useState } from "react";
import { Box, Card, CardContent, Typography, Tabs, Tab, Button, Divider, FormControlLabel, Switch, Chip } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";

import { useAccesos } from "../../../context/Catalogos/AccesosContext"; 
import SizeSoftXRouteView from "../../leyout/SizeSoftXRouteView.jsx"; 
import { CustomTabPanel } from "../../utils/CustomTabPanel";
import SizeSoftXLayoutForm from "../../leyout/SizeSoftXLayoutForm.jsx";
import MnuAccesosActions from "./MnuAccesosActions.jsx";      
import AccesosEliminar from "./AccesosEliminar.jsx";
import { useFormTabLock } from "../../../hooks/useFormTabLock";
import { useLayout } from "../../../context/System/LayoutContext";
import "../../../styles/Accesos.css";

export default function FrmAccesos() {
  const { isLocked: isFormLocked } = useFormTabLock('accesos', {
    title: 'Accesos',
    onLockDetected: (info) => {
        console.warn(`El formulario de ${info?.title || 'Accesos'} ya está abierto en otra pestaña`);
    }
  });

  const {
      usuarios,
      usuarioActual,
      menusAccesos,
      permisos,
      alcances,
      roles,
      rolSeleccionado,
      setUsuarioActual,
      accesoPayLoad,
      setAccesoPayLoad,
      getStructAccesoPayload,
      HandleCargarUsuarios,
      handleChangeDataAccesos,
      handleChangeDataAccesoPayload,
      handleChangeMenusStatus,
      handleHotKeyChange,
      handleReordenMenus,
      handleReordenMenusPadres,
      handleTogglePermiso,
      handleToggleAlcance,
      handleGuardarCambiosUsuario,
      handleNuevoUsuario,
      handleClickRegresarMainDashboard,
      handleAplicarRol,
      handleDeshacer,
      statusEnableFields,
      statusNuevo,
      hadleChangeStatusNuevo,
  } = useAccesos();

  const { handleOpenAlert } = useLayout();

  const [usuarioTexto, setUsuarioTexto] = useState("");
  const [usuarioSeleccionadoUI, setUsuarioSeleccionadoUI] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [nuevoAlcance, setNuevoAlcance] = useState("");
  const [comisionVentaText, setComisionVentaText] = useState("");

  const puedeEditar = !!usuarioActual?.id || !!usuarioActual?.isNuevo;
  const puedeModificarSecciones = !statusEnableFields;

  const opcionesUsuarios = useMemo(() => {
      const list = (usuarios ?? []).map((u) => ({
          ...u,
          label: `${u.usuario ?? ""} - ${u.nombreusuario ?? ""}`.trim(),
      }));
      list.sort((a, b) => (a.usuario ?? "").localeCompare(b.usuario ?? ""));
      return list;
  }, [usuarios]);

  const fotoSrc = useMemo(() => {
    const f = typeof usuarioActual?.foto === "string" ? usuarioActual.foto.trim() : "";
    if (!f) return "";
    if (f.startsWith("data:image")) return f;
    return `data:image/jpeg;base64,${f}`;
  }, [usuarioActual?.foto]);

  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
      HandleCargarUsuarios();
  }, []);

  useEffect(() => {
      if (!usuarioActual?.id) return;
      const found = opcionesUsuarios.find(u => u.id === usuarioActual.id);
      if (found) {
          setUsuarioSeleccionadoUI(found);
      }
  }, [usuarioActual?.id, opcionesUsuarios]);

  useEffect(() => {
      if (usuarioActual?.comisionventa !== undefined && usuarioActual?.comisionventa !== null) {
          setComisionVentaText(String(usuarioActual.comisionventa));
      }
  }, [usuarioActual?.id]);

  useEffect(() => {
    if (usuarioActual?.isNuevo) {
      setUsuarioSeleccionadoUI(null);
      setUsuarioTexto("");
      setTabIndex(0);
      setComisionVentaText("0");
    }
  }, [usuarioActual?.isNuevo]);


  useEffect(() => {
    if (isFormLocked) {
      handleOpenAlert("El formulario de Accesos ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.", "error");
      setTimeout(() => {
        if(handleClickRegresarMainDashboard) handleClickRegresarMainDashboard();
      }, 900);
    }
  }, [isFormLocked, handleClickRegresarMainDashboard, handleOpenAlert]);

  const handleComisionVentaChange = (e) => {
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
      }
      if (parts[1] && parts[1].length > 4) {
          value = parts[0] + "." + parts[1].slice(0, 4);
      }
      setComisionVentaText(value);
      const numValue = parseFloat(value);
      setUsuarioActual((prev) => ({ 
          ...prev, 
          comisionventa: Number.isFinite(numValue) ? numValue : 0 
      }));
  };

  const handleComisionVentaBlur = () => {
      const numValue = parseFloat(comisionVentaText);
      if (Number.isFinite(numValue)) {
          setComisionVentaText(String(numValue));
          setUsuarioActual((prev) => ({ ...prev, comisionventa: numValue }));
      } else {
          setComisionVentaText("0");
          setUsuarioActual((prev) => ({ ...prev, comisionventa: 0 }));
      }
  };

  const loadImage = (file) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(img);
      };
      img.onerror = (err) => {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      };
      img.src = objectUrl;
  });

  const resizeToBase64 = async (file, { maxSize = 768, quality = 0.85, mime = "image/jpeg", background = "#ffffff" } = {}) => {
    const img = await loadImage(file);
    const w = img.naturalWidth || img.width;
    const h = img.naturalHeight || img.height;
    const scale = Math.min(1, maxSize / Math.max(w, h));
    const nw = Math.max(1, Math.round(w * scale));
    const nh = Math.max(1, Math.round(h * scale));
    const canvas = document.createElement("canvas");
    canvas.width = nw;
    canvas.height = nh;
    const ctx = canvas.getContext("2d", { alpha: false });
    ctx.fillStyle = background;
    ctx.fillRect(0, 0, nw, nh);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, 0, 0, nw, nh);
    const dataUrl = canvas.toDataURL(mime, quality);
    return dataUrl.split(",")[1] ?? "";
  };

  const handleFotoChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setUsuarioActual((prev) => ({ ...prev, foto: "" }));
      return;
    }
    if (!file.type.startsWith("image/")) return;
    const maxBytes = 8 * 1024 * 1024;
    if (file.size > maxBytes) return;
    try {
      const base64Reducido = await resizeToBase64(file, { maxSize: 768, quality: 0.85, mime: "image/jpeg" });
      setUsuarioActual((prev) => ({ ...prev, foto: base64Reducido }));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <SizeSoftXLayoutForm
      titlePage="Catálogo de Accesos"
      buttonActions={<MnuAccesosActions />}
    >
      <Box sx={{ p: 2 }}>
        {/* Header */}
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
              <Autocomplete
                options={opcionesUsuarios}
                value={usuarioSeleccionadoUI}
                inputValue={usuarioTexto}
                freeSolo
                disableClearable={false}
                clearOnBlur={false}
                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                getOptionLabel={(o) => o?.label ?? ""}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === "input") setUsuarioTexto(newInputValue);
                  if (reason === "clear") setUsuarioTexto("");
                }}
                onChange={(event, newValue, reason) => {
                  if (reason === "clear") {
                    setUsuarioSeleccionadoUI(null);
                    setUsuarioTexto("");
                    setUsuarioActual(prev => ({ ...prev, id: 0, usuario: "" })); 
                    hadleChangeStatusNuevo(true);
                    handleDeshacer();
                    return;
                  }
                  if (typeof newValue === "object" && newValue?.id) {
                    setUsuarioSeleccionadoUI(newValue);
                    setUsuarioTexto(newValue.label ?? "");
                    handleChangeDataAccesos(event, newValue);
                    return;
                  }
                  if (typeof newValue === "string") {
                    setUsuarioSeleccionadoUI(null);
                    setUsuarioTexto(newValue);
                    setUsuarioActual(prev => ({ ...prev, usuario: newValue.toUpperCase() }));
                    return;
                  }
                  if (newValue == null) setUsuarioSeleccionadoUI(null);
                }}
                sx={{ width: 420 }}
                renderInput={(params) => <TextField autoComplete="off" {...params} label="Usuario" />}
              />
            </Box>
          </CardContent>
        </Card>

        {/* Tabs */}
        <Card>
          <CardContent>
            <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)}>
              <Tab label="Datos" />
              <Tab label="Menús" />
              <Tab label="Permisos" />
              <Tab label="Alcances" />
            </Tabs>

            {/* TAB: Datos */}
            <CustomTabPanel value={tabIndex} index={0}>
              {!puedeEditar ? (
                <Typography sx={{ mt: 2 }}>Selecciona un usuario para ver sus datos.</Typography>
              ) : (
              <Box sx={{ mt: 2, display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" } }}>

                {/* IZQUIERDA: CAMPOS */}
                <Box sx={{ display: "grid", gap: 2 }}>
                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "120px 1fr 1fr" } }}>
                    <TextField autoComplete="off" label="ID" name="id" value={accesoPayLoad?.id?.value ?? 0} fullWidth disabled />
                    <TextField autoComplete="off"
                      label="Usuario" name="usuario" required
                      value={accesoPayLoad?.usuario?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.usuario?.error}
                      helperText={accesoPayLoad?.usuario?.helper}
                      inputProps={{ maxLength: 50 }}
                      fullWidth
                    />
                    <TextField autoComplete="off"
                      label="Tipo usuario" name="tipousuario"
                      value={accesoPayLoad?.tipousuario?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      fullWidth
                    />
                  </Box>

                  <TextField autoComplete="off"
                    label="Nombre" name="nombreusuario" required
                    value={accesoPayLoad?.nombreusuario?.value ?? ""}
                    onChange={handleChangeDataAccesoPayload}
                    disabled={statusEnableFields}
                    error={accesoPayLoad?.nombreusuario?.error}
                    helperText={accesoPayLoad?.nombreusuario?.helper}
                    inputProps={{ maxLength: 200 }}
                    fullWidth
                  />

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" } }}>
                    <TextField autoComplete="off"
                      label="Email" name="email"
                      value={accesoPayLoad?.email?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.email?.error}
                      helperText={accesoPayLoad?.email?.helper}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                    />
                    <TextField autoComplete="off"
                      label="Teléfono" name="telefono"
                      value={accesoPayLoad?.telefono?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.telefono?.error}
                      helperText={accesoPayLoad?.telefono?.helper}
                      inputProps={{ maxLength: 20 }}
                      fullWidth
                    />
                  </Box> 

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" } }}>
                    <TextField autoComplete="off"
                      label="Puesto" name="puesto"
                      value={accesoPayLoad?.puesto?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      inputProps={{ maxLength: 100 }}
                      fullWidth
                    />
                    <TextField autoComplete="off"
                      label="CP" name="cp"
                      value={accesoPayLoad?.cp?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.cp?.error}
                      helperText={accesoPayLoad?.cp?.helper}
                      inputProps={{ maxLength: 5 }}
                      fullWidth
                    />
                  </Box>

                  <TextField autoComplete="off"
                    label="Dirección" name="direccion"
                    value={accesoPayLoad?.direccion?.value ?? ""}
                    onChange={handleChangeDataAccesoPayload}
                    disabled={statusEnableFields}
                    inputProps={{ maxLength: 300 }}
                    fullWidth
                  />

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" } }}>
                    <TextField autoComplete="off"
                      label="Colonia / Comunidad" name="coloniacomunidad"
                      value={accesoPayLoad?.coloniacomunidad?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                    />
                    <TextField autoComplete="off"
                      label="Delegación / Municipio" name="delegacionmunicipio"
                      value={accesoPayLoad?.delegacionmunicipio?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                    />
                  </Box>

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" } }}>
                    <TextField autoComplete="off"
                      label="Ciudad / Población" name="ciudadpoblacion"
                      value={accesoPayLoad?.ciudadpoblacion?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      inputProps={{ maxLength: 150 }}
                      fullWidth
                    />
                    <TextField autoComplete="off"
                      label="Roles" name="roles"
                      value={accesoPayLoad?.roles?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      inputProps={{ maxLength: 100 }}
                      fullWidth
                    />
                  </Box>

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" }, alignItems: "center" }}>
                    <TextField autoComplete="off"
                      label="Alcance (num)" name="alcance"
                      value={accesoPayLoad?.alcance?.value ?? 0}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      inputProps={{ maxLength: 10 }}
                      fullWidth
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          name="statuscomision"
                          checked={!!usuarioActual?.statuscomision}
                          onChange={(e, checked) => {
                            setUsuarioActual(prev => ({ ...prev, statuscomision: checked }));
                          }}
                        />
                      }
                      label="Comisión activa"
                    />
                    <TextField autoComplete="off"
                      label="Comisión venta" name="comisionventa"
                      value={comisionVentaText}
                      onChange={handleComisionVentaChange}
                      onBlur={handleComisionVentaBlur}
                      disabled={statusEnableFields}
                      placeholder="0.0000"
                      fullWidth
                    />
                  </Box>

                  <TextField autoComplete="off"
                    label="Adicional" name="adicional"
                    value={accesoPayLoad?.adicional?.value ?? ""}
                    onChange={handleChangeDataAccesoPayload}
                    disabled={statusEnableFields}
                    fullWidth multiline minRows={2}
                    inputProps={{ maxLength: 500 }}
                  />
                </Box>

                {/* DERECHA: FOTO */}
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Foto</Typography>
                  <Box
                    sx={{
                      width: "100%", height: 240, borderRadius: 2,
                      border: "1px solid rgba(0,0,0,.15)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      overflow: "hidden", mb: 1,
                    }}
                  >
                    {fotoSrc ? (
                      <img src={fotoSrc} alt="foto usuario" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    ) : (
                      <Typography variant="body2" color="text.secondary">Sin foto</Typography>
                    )}
                  </Box>
                  <Button variant="outlined" component="label" fullWidth disabled={statusEnableFields}>
                    Cargar foto
                    <input type="file" accept="image/*" hidden onChange={handleFotoChange} />
                  </Button>

                  <Divider sx={{ my: 2 }} />

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, alignItems: "center" }}>
                    <TextField
                      type="password" label="Password" name="password"
                      value={accesoPayLoad?.password?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.password?.error}
                      helperText={accesoPayLoad?.password?.helper}
                      inputProps={{ maxLength: 100, autoComplete: 'off' }}
                      fullWidth
                    />
                    <TextField
                      type="password" label="Confirmación" name="confirmacion"
                      value={accesoPayLoad?.confirmacion?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.confirmacion?.error}
                      helperText={accesoPayLoad?.confirmacion?.helper}
                      inputProps={{ maxLength: 100, autoComplete: 'off' }}
                      fullWidth
                    />
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, alignItems: "center" }}>
                    <TextField
                      type="password" label="Clave secreta" name="clavesecreta"
                      value={accesoPayLoad?.clavesecreta?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.clavesecreta?.error}
                      helperText={accesoPayLoad?.clavesecreta?.helper}
                      inputProps={{ maxLength: 100, autoComplete: 'off' }}
                      fullWidth
                    />
                    <TextField
                      type="password" label="Confirmación clave secreta" name="confirmacionclavesecreta"
                      value={accesoPayLoad?.confirmacionclavesecreta?.value ?? ""}
                      onChange={handleChangeDataAccesoPayload}
                      disabled={statusEnableFields}
                      error={accesoPayLoad?.confirmacionclavesecreta?.error}
                      helperText={accesoPayLoad?.confirmacionclavesecreta?.helper}
                      inputProps={{ maxLength: 100, autoComplete: 'off' }}
                      fullWidth
                    />
                  </Box>
                </Box>
              </Box>
              )}
            </CustomTabPanel>

            {/* TAB: Menús */}
            <CustomTabPanel value={tabIndex} index={1}>
              {!puedeEditar ? (
                <Typography sx={{ mt: 2 }}>Selecciona un usuario para ver sus menús.</Typography>
              ) : (
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2, flexWrap: "wrap" }}>
                    <Typography variant="subtitle2">Rol répido:</Typography>
                    <Autocomplete
                      options={roles ?? []}
                      onChange={(e, v) => handleAplicarRol?.(v)}
                      value={rolSeleccionado || accesoPayLoad?.tipousuario?.value || null}
                      disabled={!puedeModificarSecciones}
                      sx={{ width: 260 }}
                      renderInput={(params) => <TextField autoComplete="off" {...params} label="Rol" />}
                    />
                    <Typography variant="caption" color="text.secondary">
                      (PERSONALIZAR) Arrastra las 3 rayas para ordenar grupos y péginas de arriba hacia abajo. Guarda cambios.
                    </Typography>
                  </Box>
                  <Box className="route-menu-select">
                    <SizeSoftXRouteView
                      data={menusAccesos}
                      withCheckboxes={true}
                      onChange={() => {}}
                      icons={{ default: MenuIcon }}
                      changeDataStatus={handleChangeMenusStatus}
                      onHotKeyChange={handleHotKeyChange}
                      onReorder={handleReordenMenus}
                      onReorderParents={handleReordenMenusPadres}
                      disabled={!puedeModificarSecciones}
                    />
                  </Box>
                </Box>
              )}
            </CustomTabPanel>

            {/* TAB: Permisos */}
            <CustomTabPanel value={tabIndex} index={2}>
              {!puedeEditar ? (
                <Typography sx={{ mt: 2 }}>Selecciona un usuario para ver permisos.</Typography>
              ) : permisos?.length ? (
                <Box sx={{ mt: 2, display: "grid", gap: 1 }}>
                  {permisos.map((p) => (
                    <Box
                      key={p.modulo}
                      sx={{
                        display: "flex", alignItems: "center", justifyContent: "space-between",
                        border: "1px solid rgba(0,0,0,.08)", borderRadius: 2, p: 1,
                      }}
                    >
                      <Typography>{p.modulo}</Typography>
                      <Switch 
                        checked={!!p.status} 
                        disabled={!puedeModificarSecciones}
                        onChange={() => handleTogglePermiso(p.modulo)}
                      />
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography sx={{ mt: 2 }}>Este usuario no tiene permisos configurados.</Typography>
              )}
            </CustomTabPanel>

            {/* TAB: Alcances */}
            <CustomTabPanel value={tabIndex} index={3}>
              {!puedeEditar ? (
                <Typography sx={{ mt: 2 }}>Selecciona un usuario para ver alcances.</Typography>
              ) : (
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                    <TextField autoComplete="off"
                      label="Nuevo alcance"
                      value={nuevoAlcance}
                      onChange={(e) => setNuevoAlcance(e.target.value.toUpperCase())}
                      disabled={!puedeModificarSecciones}
                      sx={{ width: 280 }}
                    />
                    <Button
                      variant="contained"
                      disabled={!puedeModificarSecciones}
                      onClick={() => {
                        const a = nuevoAlcance.trim().toUpperCase();
                        if (!a) return;
                        handleToggleAlcance(a);
                        setNuevoAlcance("");
                      }}
                    >
                      Agregar
                    </Button>
                  </Box>
                  <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
                    {(alcances ?? []).map((a) => (
                      <Chip
                        key={a.alcance}
                        label={a.alcance}
                        onDelete={puedeModificarSecciones ? () => handleToggleAlcance(a.alcance) : undefined}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </CustomTabPanel>
          </CardContent>
        </Card>
      </Box>
      <AccesosEliminar />
    </SizeSoftXLayoutForm>
  );
}
